const release = {
  commit: "50a7ef05ed8e501f77da7a41eccc8cf4f01818b4",
  version: "202505.81708.20",
};

export default release;
